import { Injectable } from '@angular/core';
import { Color } from '@app/models/color';
import { File } from '@app/models';
import * as FileActions from '@core/actions/file.actions';
import { ColorService } from '@app/services/api/color.service';
import { FlashService } from '@app/services/flash.service';
import {
  AddAll,
  AddOne,
  ColorActionTypes,
  Create,
  CreateFail,
  CreateSuccess,
  ExportColor,
  Load,
  LoadFail,
  LoadSuccess,
  Update,
  UpdateFail,
  UpdateOne,
  UpdateSuccess,
  GetUploadLink,
  GetUploadLinkFail,
  GetUploadLinkSuccess,
  UploadFile,
  UploadFileFail,
  UploadFileSuccess,
  ProcessFile,
  ProcessFileUpdate,
  ProcessFileFail,
  ProcessFileSuccess,
  NotifyFileUpload,
  GetUploadLinkMassive,
  GetUploadLinkFailMassive,
  GetUploadLinkSuccessMassive,
  GetColorsLink,
  GetColorsLinkFail,
  UploadColor,
  UploadColorFail,
  UploadColorSuccess,
  UploadProcessUpdateColor,
  UploadProcessSuccess,
  UploadProcessFail,
  ColorProcessSuccess,
  ColorProcessFail,
  DeleteColor,
  DeleteColorSuccess,
} from '@core/actions/color.actions';

import * as ColorActions from '@core/actions/color.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  catchError,
  map,
  switchMap,
  tap,
  exhaustMap,
  concatMap
} from 'rxjs/operators';
import { ApiService } from '@app/services/api/api.service';
import { WebsocketService } from '@app/services/websocket.service';
import { Store } from '@ngrx/store';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';

@Injectable()
export class ColorEffects {
  _processing = {};
  _timer;

  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(ColorActionTypes.Load),
    map(action => action.FollowId),
    switchMap(id => {
      return this.colorsApi.get(id).pipe(
        map((colors: Color[]) => new LoadSuccess(colors)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(ColorActionTypes.LoadSuccess),
    map(action => new AddAll(action.colors))
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(ColorActionTypes.Create),
    switchMap(action =>
      this.colorsApi.create(action.followId, action.color).pipe(
        map((savedColor: Color) => new CreateSuccess(savedColor)),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  createFailFail$ = this.actions$.pipe(
    ofType<CreateFail>(ColorActionTypes.CreateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo crear el color',
        type: 'danger'
      })
    )
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(ColorActionTypes.CreateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Color creado' });
      return new AddOne(action.color);
      // concatmap para devolver otra accion
    })
    // tap(
    //   x => console.log('asjkd', x)
    //   //   this.store.dispatch(
    //   //   // new GetUploadLink(x.color.id, x.file)
    //   // )
    // )
  );
  
  @Effect()
  deleteColor$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteColor>(ColorActionTypes.DeleteColor),
    map(action => [action.idColor, action.followId]),
    switchMap(([idColor, followId]) => {
      return this.colorsApi.delete(idColor, followId).pipe(
        map(() => new DeleteColorSuccess(followId))
      );
    })
  );
  
  @Effect()
  DeleteColorSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteColorSuccess>(ColorActionTypes.DeleteColorSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Color Eliminado' });
      return new Load(action.followId);
    })
  );
  

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(ColorActionTypes.Update),
    map(action => [action.followId, action.data]),
    switchMap(([followId, data]) => {
      return this.colorsApi.update(followId, data).pipe(
        map((color: Color) => new UpdateSuccess(color.id, color)),
        catchError(error => of(new UpdateFail(error)))
      );
    })
  );

  @Effect()
  updateSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateSuccess>(ColorActionTypes.UpdateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Color actualizado' });
      return new UpdateOne(action.data);
    })
    // map(action => {
    //   this.fs.emit({ type: 'fail', message: 'No se pudo actualizar'});
    //   return new UpdateFail(action.color);
    // })
  );

  @Effect()
  UpdateSuccess$ = this.actions$.pipe(
    ofType<UpdateOne>(ColorActionTypes.UpdateOne),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Colores actualizados' });
      return new Load(action.color.FollowId)
    })
  );

  @Effect({ dispatch: false })
  updateFail$ = this.actions$.pipe(
    ofType<UpdateFail>(ColorActionTypes.UpdateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'Color no actualizado',
        type: 'danger'
      })
    )
  );

  @Effect({ dispatch: false })
  exportColor$ = this.actions$.pipe(
    ofType<ExportColor>(ColorActionTypes.ExportColor),
    map(action => [action.id, action.name, action.type]),
    tap(
      ([id, data, type]) => this.api.exportFollowColors(id, data, type),
      tap(() => console.log('done'))
    )
  );

  @Effect()
  getLink$ = this.actions$.pipe(
    ofType<GetUploadLink>(ColorActionTypes.GetUploadLink),
    map(action => [action.colorId, action.file, action.featured, action.followId]),
    exhaustMap(([colorId, file, uploadType, followId]) =>
      this.api.getColorFileUploadLink(colorId, file, uploadType).pipe(
        concatMap((link: any) => {
          return [new UploadFile(link, file, followId)];
        }),
        catchError(error => of(new GetUploadLinkFail(error)))
      )
    )
  );

  @Effect()
  uploadFile$ = this.actions$.pipe(
    ofType<UploadFile>(ColorActionTypes.UploadFile),
    map(action => [action.link, action.file, action.followId]),
    exhaustMap(([link, file, followId]: [any, any, any]) => {
      const url = link.signedUrl;
      const fileId = link.id;

      return this.api.uploadFollowFile(url, file).pipe(
        concatMap(response => {
          // this.ws.registerFileListener(fileId);
          return [new NotifyFileUpload(fileId, followId)];
        }),
        catchError(error => {
          return of(new UploadFileFail(error));
        })
      );
    })
  );

  @Effect()
  notifyFileUpload$ = this.actions$.pipe(
    ofType<NotifyFileUpload>(ColorActionTypes.NotifyFileUpload),
    map(action => [action.id, action.followId] ),
    exhaustMap(([id, followId]) => {
      return this.api.notifyFileUpload(id).pipe(
        concatMap((file: File) => {
          return [
            new UploadFileSuccess(followId),
            new FileActions.AddOne(file),
            file.featured
              ? new ColorActions.AddPicture(file)
              : new ColorActions.AddToFileCount(file.ProductId)
            // file.FileableId = Color.Id
            // file.FileableType = 'Color'
            // console.log('sssss-->>', file)
          ];
          // this._processing = { [id]: true };
          // this._timer = setTimeout(() => this.checkProcessing(id), 300000);
          // return [new ProcessFile(), new UploadFileSuccess()];
        }),
        catchError(error => {
          return of(new UploadFileFail(error));
        })
      );
    })
  );

  @Effect({ dispatch: false })
  UploadFileSuccess$ = this.actions$.pipe(
    ofType<UploadFileSuccess>(ColorActionTypes.UploadFileSuccess),
    map(action => {
      //this.fs.emit({ type: 'success', message: 'Colores actualizados' });
      return new Load(action.followId)
    })
  );

  @Effect()
  processSuccess$ = this.actions$.pipe(
    ofType<ProcessFileSuccess>(ColorActionTypes.ProcessFileSuccess),
    map(action => action.job.FileId),
    tap(id => {
      if (this._processing[id]) {
        this._processing[id] = false;
      }
    })
  );

  @Effect()
  getLinkMassive$ = this.actions$.pipe(
    ofType<GetUploadLinkMassive>(ColorActionTypes.GetUploadLinkMassive),
    map(action => [action.colorId, action.file, action.featured]),
    exhaustMap(([colorId, file, featured]) =>
      this.api.getUploadLinkMassiveColors(colorId, file, featured).pipe(
        concatMap((link: any) => {
          // console.log('SEGUNDO LLAMADO A LA API');
          return [new UploadFile(link, file, colorId)];
        }),
        catchError(error => of(new GetUploadLinkFail(error)))
      )
    )
  );

  /*********/
  @Effect()
  getColorLink$ = this.actions$.pipe(
    ofType<GetColorsLink>(ColorActionTypes.GetColorsLink),
    map(action => [action.owner, action.file, action.uploadType]),
    exhaustMap(([followId, file]) =>
      this.api.getColorUploadLink(followId, file).pipe(
        concatMap((link: any) => {
          return [new UploadColor(link, file, followId)];
        }),
        catchError(error => of(new GetColorsLinkFail(error)))
      )
    )
  );

  /*********/
  @Effect({ dispatch: false })
  getColorLinkFail$ = this.actions$.pipe(
    ofType<GetColorsLinkFail>(ColorActionTypes.GetColorsLinkFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        type: 'danger',
        message: 'Error al cargar Colores'
      })
    )
  );

  /*********/
  @Effect()
  uploadColors$ = this.actions$.pipe(
    ofType<UploadColor>(ColorActionTypes.UploadColor),
    map(action => [action.link, action.file]),
    exhaustMap(([link, file]: [any, any]) => {
      const url = link.signedUrl;
      const fileId = link.id;
      return this.api.uploadFile(url, file).pipe(
        concatMap(response => {
          this.ws.registerFileListener(fileId);
          return [new UploadColorSuccess(fileId)];
        }),
        catchError(e => {
          return of(new UploadColorFail(e));
        })
      );
    })
  );

  /*********/
  @Effect()
  uploadColorSuccess$ = this.actions$.pipe(
    ofType<UploadColorSuccess>(ColorActionTypes.UploadColorSuccess),
    map(action => action.data),
    switchMap((FileId: number) => {
      return this.api
        .notifyFileUpload(FileId, { processType: 'LoadColors' })
        .pipe(
          map(action => {
            return new UploadProcessUpdateColor(action);
          }),
          catchError(e => of(new ColorProcessFail(e)))
        );
    })
  );

  /*********/
  @Effect({ dispatch: false })
  colorProcessSuccess$ = this.actions$.pipe(
    ofType<ColorProcessSuccess>(ColorActionTypes.ColorProcessSuccess),
    map(() => {
      this.fs.emit({ type: 'success', message: 'Colores actualizados' });
      // return new Load(action.data.FollowId);
    })
  );

  /*********/
  @Effect({ dispatch: false })
  colorProcessFail$ = this.actions$.pipe(
    ofType<ColorProcessFail>(ColorActionTypes.ColorProcessFail),
    map(() => {
      this.fs.emit({
        type: 'fail',
        message: 'Error al cargar colores'
      });
    })
  );

  /*********/

  // UploadProcessUpdateColor;

  // @Effect()
  // uploadProcessUpdateColor$ = this.actions$.pipe(
  //   ofType<UploadProcessUpdateColor>(ColorActionTypes.UploadProcessUpdateColor),
  //   map(action => [action]),
  //   exhaustMap(([link, file]: [any, any]) => {
  //     console.log('LALALALALAL', link);
  //     const url = link.signedUrl;
  //     const fileId = link.id;
  //     return this.api.uploadFile(url, file).pipe(
  //       concatMap(response => {
  //         // this.ws.registerFileListener(fileId);
  //         return [];
  //         return [new UploadProcessSuccess()];
  //       }),
  //       catchError(e => {
  //         console.log('HAHAHHAAH');
  //         console.log(e);
  //         // return console.log('adasd');
  //         // return of(new UploadProcessFail(e));
  //         return [];
  //       })
  //     );
  //   })
  // );

  @Effect()
  uploadProcessSuccess$ = this.actions$.pipe(
    ofType<UploadProcessSuccess>(ColorActionTypes.UploadProcessSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Colores actualizados' });
      return new Load(action.data.FollowId)
    })
  );

  @Effect({ dispatch: false })
  uploadProcessFail$ = this.actions$.pipe(
    ofType<UploadProcessFail>(ColorActionTypes.UploadProcessFail),
    map(action => {
      this.fs.emit({
        type: 'danger',
        message: 'No se pudieron actualizar los colores'
      });
    })
  );

  checkProcessing(id) {
    if (this._processing[id]) {
      this.fs.emit({ type: 'danger', message: 'Error de tiempo de espera' });
      this.store.dispatch(new ProcessFileFail());
    }
  }

  constructor(
    private actions$: Actions,
    private colorsApi: ColorService,
    private fs: FlashService,
    private api: ApiService,
    private ws: WebsocketService,
    private store: Store<any>
  ) {}
}
